import styled, { css, space, flexbox } from '@styled'

export const LogoWrapper = styled.div`
  display: flex;
  ${flexbox};
  ${space};
  overflow: hidden;
  height: 60px;
  a {
    display: flex;
    align-items: center;
    img {
      width: 200px;
      min-width: 200px;
    }
  }

  ${({ $variant }) =>
    $variant === 'white' &&
    css`
      .dark-logo {
        display: none !important;
      }
      .light-logo {
        display: inherit;
      }
    `}
  ${({ $variant }) =>
    $variant === 'dark' &&
    css`
      .dark-logo {
        display: inherit;
      }
      .light-logo {
        display: none !important;
      }
    `}
`
